module.exports = __webpack_public_path__ + "static/media/ensuenio-frente.c5ebc286.jpeg";